import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './BookmarkList.css';
import Loading from '../../common/Loading';

function BookmarkList() {
  const [bookmarks, setBookmarks] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://api.mutantbutton2.com/public/bookmarks')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch bookmarks');
        }
        return response.json();
      })
      .then(data => {
        setBookmarks(data.bookmarks || {});
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching bookmarks:', error);
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="bookmark-list"><Loading /></div>;
  }

  if (error) {
    return <div className="bookmark-list error">Error: {error}</div>;
  }

  const hasBookmarks = Object.keys(bookmarks).length > 0;

  return (
    <div className="bookmark-list">
      <nav className="breadcrumb">
        <NavLink to="/">Home</NavLink>
        <span className="separator">></span>
        <span className="current">Bookmarks</span>
      </nav>
      
      <h1>All Bookmarks</h1>
      {!hasBookmarks ? (
        <p className="no-bookmarks">No bookmarks available yet.</p>
      ) : (
        Object.entries(bookmarks).map(([section, items]) => (
          <div key={section} className="bookmark-section">
            <h2>#{section}</h2>
            <div className="bookmarks-grid">
              {items.map((bookmark, index) => {
                const formattedName = bookmark.name
                  .split('-')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  .join(' ');
                
                return (
                  <NavLink
                    key={index}
                    to={`/bookmarks/${section}/${bookmark.name}`}
                    className="bookmark-card"
                  >
                    <div className="bookmark-card-content">
                      <h3>{formattedName}</h3>
                      <span className="bookmark-arrow">→</span>
                    </div>
                  </NavLink>
                );
              })}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default BookmarkList;
